import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CheckboxItem } from './sg-checkbox.model';

@Component({
  selector: 'sg-checkbox',
  templateUrl: './sg-checkbox.component.html',
  styleUrls: ['./sg-checkbox.component.scss'],
  standalone: false,
})
export class SgCheckboxComponent {
  @Input() items: CheckboxItem[] = [];
  @Input() alignment?: 'vertical' | 'horizontal' = 'vertical';
  @Input() errorMessage?: string;
  @Input() disabled = false;
  @Input() labelPosition: 'left' | 'right' = 'right';
  @Output() valueChange = new EventEmitter<any>();

  onValueChange(item: CheckboxItem, parent?: CheckboxItem): void {
    if (item?.children?.length > 0) {
      const newChecked = !this.areAllChildrenChecked(item);
      item.children.forEach((child) => (child.checked = newChecked));
    } else {
      item.checked = !item.checked;

      if (parent) {
        parent.checked = this.areAllChildrenChecked(parent);
      }
    }
    this.valueChange.emit(this.items);
  }

  isIndeterminate(item: CheckboxItem): boolean {
    if (!item?.children || item?.children?.length === 0) return false;
    const checkedCount = item.children.filter((child) => child.checked).length;
    return checkedCount > 0 && checkedCount < item.children.length;
  }

  areAllChildrenChecked(item: CheckboxItem): boolean {
    return item?.children?.every((child) => child.checked) ?? false;
  }

  getGroupAlignment(item: CheckboxItem): 'vertical' | 'horizontal' {
    return item?.children?.length > 0 ? 'vertical' : (this.alignment ?? 'horizontal');
  }

  hasAnyGroup(): boolean {
    return this.items?.some((item) => item.children?.length > 0);
  }
}
